import { Component, inject, Input, OnInit } from '@angular/core';
import {
  DeviceActionStackService,
  EdroNetworkManager,
  FunctionOnglet,
} from '../../../../../../manager/edro-network-manager';
import { IProduct, IProductFunctionnality } from '../../../../../IProduct';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import {
  LargedTuileComponent,
  TuileButtonProps,
} from '../../../../../../../../components/ecosystems/larged-tuile/larged-tuile.component';
import { getPoolMasterClass } from '../../../../../../ECoSystemsHelper';
import { P00031 } from '../../../../P00031';
import { P00039DataRxTxIndex } from '../../../../P00039Sync';

@Component({
  selector: 'app-p00039-card-eclairage-controle',
  templateUrl: './p00039-card-eclairage-controle.component.html',
  styleUrls: ['./p00039-card-eclairage-controle.component.scss'],
  imports: [LargedTuileComponent, TranslatePipe],
})
export class P00039CardEclairageControleComponent implements OnInit {
  private edroNetworkManager = inject(EdroNetworkManager);
  private translateService = inject(TranslateService);
  @Input() productClass: IProduct | null = null;
  public actionStack: DeviceActionStackService | null = null;

  public buttons: TuileButtonProps[] = [];

  constructor() {}

  hasP00031() {
    const master = getPoolMasterClass(
      this.edroNetworkManager.getPoolContext()!.pool!,
    );
    return (
      master!.hasProduct(
        this.edroNetworkManager.getPoolContext()!.pool!,
        new P00031(),
      ) > 0
    );
  }

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      null,
    );

    this.buttons = [
      {
        title: 'P00039.card.state.lighting.title.off',
        icon: 'fa-kit fa-picto-off',
        color: 'color-red',
        status: 'inactive',
      },
      {
        title: 'P00039.card.state.lighting.title.on',
        icon: 'fa-kit fa-picto-on',
        color: 'color-green',
        status: 'active',
      },
      {
        title: 'P00039.card.state.lighting.title.clock',
        icon: 'fa-kit fa-picto-horloge',
        color: 'color-orange',
        status: 'inactive',
      },
    ];
  }

  async openProductModal() {
    await this.edroNetworkManager.openProductModal(
      this.productClass!,
      IProductFunctionnality.ECLAIRAGE,
      FunctionOnglet.CONTROL,
      this.translateService.instant('dashboard.lighting'),
    );
  }

  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
}
